type Listener = (show: boolean) => void;
let listeners: Listener[] = [];

export const tourStore = {
  show() {
    listeners.forEach(l => l(true));
  },
  hide() {
    listeners.forEach(l => l(false));
  },
  subscribe(listener: Listener): () => void {
    listeners.push(listener);
    return () => {
      listeners = listeners.filter(l => l !== listener);
    };
  },
};
